import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

const Section = ({ title, children }) => (
  <div className="mb-8 md:mb-10">
    <h2 className="text-xl md:text-2xl font-heading text-headingText mb-3 md:mb-4">{title}</h2>
    <div className="text-sm md:text-base text-bodyText leading-relaxed space-y-3">{children}</div>
  </div>
);

const InfoCard = ({ icon, title, value }) => (
  <div className="flex items-start gap-3 bg-primaryBg rounded-xl p-4">
    <span className="text-2xl">{icon}</span>
    <div>
      <p className="font-medium text-headingText text-sm md:text-base">{title}</p>
      <p className="text-bodyText text-sm">{value}</p>
    </div>
  </div>
);

export default function ShippingPolicy() {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* Header */}
      <div className="text-center mb-10 md:mb-14">
        <p className="text-secondary font-medium tracking-widest text-xs md:text-sm uppercase mb-3">Legal</p>
        <h1 className="text-3xl md:text-5xl font-heading text-headingText mb-4">Shipping Policy</h1>
        <p className="text-sm text-bodyText opacity-70">Last updated: March 22, 2026</p>
      </div>

      <div className="bg-cardBg rounded-2xl p-6 md:p-10 shadow-sm">

        <Section title="Delivery Overview">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 my-4">
            <InfoCard icon="📦" title="Processing Time" value="1–2 business days" />
            <InfoCard icon="🚚" title="Standard Delivery" value="5–7 business days" />
            <InfoCard icon="⚡" title="Express Delivery" value="2–3 business days (select cities)" />
          </div>
          <p>All orders are shipped from Noida, Uttar Pradesh, India.</p>
        </Section>

        <Section title="Shipping Charges">
          <div className="overflow-x-auto rounded-xl border border-gray-200 my-4">
            <table className="w-full text-sm md:text-base">
              <thead className="bg-secondary/10">
                <tr>
                  <th className="px-4 py-3 text-left font-heading text-headingText">Order Value</th>
                  <th className="px-4 py-3 text-left font-heading text-headingText">Standard</th>
                  <th className="px-4 py-3 text-left font-heading text-headingText">Express</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-primaryBg">
                  <td className="px-4 py-3">Below ₹500</td>
                  <td className="px-4 py-3">₹60</td>
                  <td className="px-4 py-3">₹120</td>
                </tr>
                <tr className="bg-cardBg">
                  <td className="px-4 py-3">₹500 – ₹999</td>
                  <td className="px-4 py-3">₹40</td>
                  <td className="px-4 py-3">₹100</td>
                </tr>
                <tr className="bg-primaryBg">
                  <td className="px-4 py-3">₹1,000 and above</td>
                  <td className="px-4 py-3 text-green-700 font-medium">Free</td>
                  <td className="px-4 py-3">₹80</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="Delivery Areas">
          <p>
            We currently ship to all major cities and towns across <strong>India</strong>. Remote or PIN-code
            restricted areas may experience additional 2–3 day delays.
          </p>
          <p>
            <strong>International shipping</strong> is not available at this time. We aim to expand globally
            in the near future.
          </p>
        </Section>

        <Section title="Order Tracking">
          <p>
            Once your order is dispatched, you will receive a tracking number via email. You can track your
            order using the courier partner's website or via{' '}
            <button
              onClick={() => navigate('/orders')}
              className="text-secondary hover:underline cursor-pointer"
            >
              Order History
            </button>{' '}
            in your account.
          </p>
        </Section>

        <Section title="Delays & Exceptions">
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Orders placed on public holidays are processed the next business day</li>
            <li>Natural disasters, strikes, or courier disruptions may cause delays</li>
            <li>Incorrect address provided at checkout — Panch Tatva is not liable</li>
          </ul>
          <p>
            For any shipping concerns, please email{' '}
            <a href="mailto:support@panch-tatva.co.in" className="text-secondary hover:underline">
              support@panch-tatva.co.in
            </a>
          </p>
        </Section>

        <Section title="Packaging">
          <p>
            All orders are packaged in eco-conscious, recyclable materials that reflect the elemental philosophy
            of Panch Tatva. Gift sets include signature gift wrapping at no extra charge.
          </p>
        </Section>

      </div>

      <div className="mt-10 text-center">
        <PanchTatvaButton onClick={() => navigate(-1)} variant="outline">
          ← Go Back
        </PanchTatvaButton>
      </div>
    </div>
  );
}
